<template>
  <div class="main-container" v-if="!loading">
    <HeaderShowcase/>
    <HeroAppShowcase/>
    <FeatureAppShowcase/>
    <ThreeStepProcessWrap/>
    <AppShowcaseNewsletter/>
    <FooterAppShowcase/>
    <OverlayMenu/>
  </div>
</template>

<script>
import HeaderShowcase from "../components/HeaderShowcase";
import HeroAppShowcase from "../components/HeroAppShowcase";
import FeatureAppShowcase from "../components/FeatureAppShowcase";
import ThreeStepProcessWrap from "../components/ThreeStepProcessWrap";
import AppShowcaseNewsletter from "../components/sections/AppShowcaseNewsletter";
import FooterAppShowcase from "../components/FooterAppShowcase";
import OverlayMenu from "../components/OverlayMenu";

export default {
  name: "app",
  components: {
    HeaderShowcase,
    HeroAppShowcase,
    FeatureAppShowcase,
    ThreeStepProcessWrap,
    AppShowcaseNewsletter,
    FooterAppShowcase,
    OverlayMenu,
  },

  metaInfo: {
    title: 'Dezinfekce potrubí, dezinfekce vodovodů a řadů, protokol o dezinfekci potrubí',
    htmlAttrs: {
      lang: 'cs',
      amp: true
    }
  },
  computed: {
    loading() {
      return this.$store.getters['app/loading']
    },
  },
  mounted() {
    this.$store.dispatch('app/init')
  }
};
</script>

